import React from 'react';
import './style.css';
import SessionStore from '../../components/Stores/SessionStore';

export default class Logout extends React.Component {

	componentWillMount() {
		const sessionStore = new SessionStore();
		sessionStore.clear();
        this.props.history.push("/Sign");
	}

	render() {
		return null;
	}
}



/** WEBPACK FOOTER **
 ** ./src/containers/Logout/index.js
 **/